/**
 * Jóvenes Independientes - Main Application
 * Sistema de guía hipotecaria para España
 */

import './style.css';
import { Router } from './router.js';
import { renderLanding } from './pages/landing.js';
import { renderAuth } from './pages/auth.js';
import { renderOnboarding } from './pages/onboarding.js';
import { renderDashboard } from './pages/dashboard.js';
import { renderGuide } from './pages/guide.js';
import { renderExpenses } from './pages/expenses.js';
import { renderSavings } from './pages/savings.js';
import { renderAids } from './pages/aids.js';

import { renderTerms } from './pages/terms.js';
import { renderPrivacy } from './pages/privacy.js';
import { renderCookies } from './pages/cookies.js';
import { renderTemplates } from './pages/templates.js';
import { renderSubscription } from './pages/subscription.js';
import { initFeatherIcons } from './utils/icons.js';

// Initialize router
const router = new Router();

// Define routes
router.addRoute('/', renderLanding);
router.addRoute('/auth', renderAuth);
router.addRoute('/onboarding', renderOnboarding);
router.addRoute('/dashboard', renderDashboard);
router.addRoute('/guia', renderGuide);
router.addRoute('/gastos', renderExpenses);
router.addRoute('/ahorro', renderSavings);
router.addRoute('/ayudas', renderAids);
router.addRoute('/suscripcion', renderSubscription);

// Legal pages
router.addRoute('/terminos', renderTerms);
router.addRoute('/privacidad', renderPrivacy);
router.addRoute('/cookies', renderCookies);

// Store - Templates
router.addRoute('/plantillas', renderTemplates);

// Start router
router.init();

// Initialize Feather Icons after DOM updates
document.addEventListener('routeChanged', () => {
  initFeatherIcons();
});

// Initial icon initialization
initFeatherIcons();

// Export router for use in other modules
window.router = router;

console.log('🏠 Jóvenes Independientes initialized');

